module.exports = __webpack_public_path__ + "media/images/web/home/index/header_bg_m-c137cadc5c42464c6b2eb9a004cbdfdf.jpg";